import React, { useEffect, useRef } from "react";
import styles from "./payment.module.scss";
import { useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import { toast } from "react-toastify";
import Axios from "axios";
import { useDispatch } from "react-redux";
import { DEV } from "../../services/constants";
import { handlePutRequest } from "../../services/PutTemplate";
import { useParams, useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { PayPalScriptProvider, PayPalButtons, PayPalHostedFieldsProvider, PayPalHostedField, usePayPalHostedFields } from "@paypal/react-paypal-js";
import { handlePostRequest } from "../../services/PostTemplate";
import { loadScript } from "@paypal/paypal-js";
import AmazonPayButton from "../../components/AmazonPayButton";

//84da549f75e89e8f82b3d70970f9ab87
//538a0fe96c68760103c727eda11bff8a

// Hoisted out of Payment() so its component identity stays stable across
// parent re-renders (e.g. ticking the terms checkbox) - defined inline, a
// re-render of Payment would create a new SubmitPayment function on every
// pass, making React unmount/remount it and wipe the uncontrolled
// cardHolderName input along with it.
const SubmitPayment = ({ customStyle, paidAmount, brands, checked, setChecked, isPickupPlan, commitPickupPayment, redirectAfterPayment, setLoading, setDisabled, dispatch, closed }) => {
    const [paying, setPaying] = useState(false);
    const cardHolderName = useRef(null);
    const hostedField = usePayPalHostedFields();

    const handleClick = async () => {
        if (paidAmount === 0) {
            toast.error("Please enter valid amount to pay");
            setPaying(false);
        } else if (paidAmount > parseFloat(brands?.invoiceAmount)) {
            toast.error("Amount should be less than or equal to total amount");
            setPaying(false);
        } else if (!checked) {
            toast.error("Please agree to the terms and conditions");
            setPaying(false);
        } else {
            if (!hostedField?.cardFields) {
                const childErrorMessage = "Unable to find any child components in the <PayPalHostedFieldsProvider />";
                setPaying(false);

                // action(ERROR)(childErrorMessage);
                // throw new Error(childErrorMessage);
            }
            const isFormInvalid = Object.values(hostedField.cardFields.getState().fields).some((field) => !field.isValid) || !cardHolderName?.current?.value;

            if (isFormInvalid) {
                toast.error("Please fill all the required fields");
                toast.error("We appreciate your effort to make a payment. Please check your card information for errors, or try again in ten minutes.");
                setPaying(false);
            }
            setPaying(true);
            hostedField.cardFields
                .submit({
                    cardholderName: cardHolderName?.current?.value,
                    postalCode: hostedField?.postalCodeFields?.getState().fields.postalCode.value,
                    // billingAddress:{
                    //     postalCode: hostedField?.postalCodeFields?.getState().fields.postalCode.value,
                    // }
                })
                .then(async (data) => {
                    console.log(data?.orderId);
                    // Your logic to capture the transaction
                    const res = await dispatch(handlePostRequest({ orderId: data?.orderId }, "/captureOrder"));
                    if (res?.success) {
                        if (res?.data?.purchase_units?.[0]?.payments?.captures?.[0]?.status === "COMPLETED") {
                            if (isPickupPlan) {
                                const resp = await commitPickupPayment(data?.orderId);
                                if (!resp?.success) {
                                    setLoading(false);
                                    setDisabled(false);
                                }
                                setPaying(false);
                                return;
                            }
                            const dat = {
                                invoiceNo: res?.data?.purchase_units?.[0]?.payments?.captures?.[0]?.id,
                                id: brands?._id,
                                paymentStatus: "paid",
                                paidAmount: paidAmount,
                                invoiceAmount: parseFloat(brands?.invoiceAmount),
                                paymentMethod: "Card",
                            };
                            const resp = await handlePutRequest(dat, "/markInvoicePaid");
                            if (resp?.success) {
                                const delayTime = new Date().getTime() + 1 * 60 * 1000; // 2 minutes in milliseconds
                                localStorage.setItem("delayExpiration", delayTime);
                                redirectAfterPayment(brands?._id);
                                localStorage.removeItem("invoiceId");
                                localStorage.removeItem("PaymentUser");
                            } else {
                                setLoading(false);
                                setDisabled(false);
                            }
                            toast.success("Success!!! Thank you for choosing Move4wd. Have a wonderful rest of your day! #MoveYourWorld");
                            setPaying(false);
                        } else {
                            toast.error("We appreciate your effort to make a payment. Please check your card information for errors, or try again in ten minutes.");
                            setPaying(false);
                        }
                    } else {
                        toast.error("We appreciate your effort to make a payment. Please check your card information for errors, or try again in ten minutes.");
                        setPaying(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // Here handle error
                    toast.error("We appreciate your effort to make a payment. Please check your card information for errors, or try again in ten minutes.");
                    setPaying(false);
                });
        }
    };

    return (
        <>
            <div className={styles.fieldGroup}>
                <label title="This represents the full name as shown in the card">Card Holder Name</label>
                <input id="card-holder" ref={cardHolderName} className={`card-field ${styles.textInput}`} type="text" placeholder="Full name" />
            </div>
            <div className={styles.termsRow}>
                <input type="checkbox" className={styles.termsCheckbox} checked={checked ? true : false} onChange={(e) => setChecked(!checked)}></input>
                <label className={styles.termsLabel}>
                    I have read and agree to the website{" "}
                    <a href="https://zazio.co/terms/" target="_blank" rel="noreferrer">
                        terms and conditions*
                    </a>
                </label>
            </div>
            <div className={styles.payButtonRow}>
                {paying ? (
                    <div>
                        <ClipLoader color="green" loading={paying} size={50} aria-label="Loading Spinner" data-testid="loader" />
                    </div>
                ) : (
                    <button className={styles.payButton} onClick={handleClick} disabled={closed === true ? true : false}>
                        {paying ? <div className="spinner tiny" /> : `${closed ? "Please wait 1 minute" : `Pay $${paidAmount}`}`}
                    </button>
                )}
            </div>
        </>
    );
};

function Payment() {
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [clientToken, setClientToken] = useState();
    const history = useHistory();
    // const elements = clover.elements();
    const [user, setUser] = useState();
    const [brands, setBrands] = useState();
    const [closed, setClosed] = useState(false);
    const [paidAmount, setPaidAmount] = useState(0);
    const [amount, setAmount] = useState(0);
    const [role, setRole] = useState();

    // In-store pickup's Card option stages a plan here instead of a single
    // invoiceId - the panel already decided (server-validated on commit) how
    // a possibly multi-invoice total should be allocated, so this page only
    // needs to charge that exact total and hand the plan back to
    // pay-card-commit once PayPal confirms the capture. Every other entry
    // point into this page (client self-service, admin/single-invoice) is
    // untouched by this branch.
    const [pickupPlan] = useState(() => {
        try {
            const raw = localStorage.getItem("pickupCardPlan");
            // Consumed once, right here, regardless of what happens next on this
            // page - an abandoned or failed pickup payment must never leave this
            // sitting in localStorage to hijack some unrelated later visit to
            // /payment (e.g. a client paying their own invoice on the same
            // browser) into rendering the wrong amount.
            localStorage.removeItem("pickupCardPlan");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    });
    const isPickupPlan = !!pickupPlan;

    // If this page was opened from somewhere that wants control back after
    // payment (e.g. in-store pickup's "Pay by Card" hop), it stashes the
    // path to return to in localStorage before navigating here. Otherwise
    // fall back to the normal invoice-page redirect.
    const redirectAfterPayment = (fallbackInvoiceId) => {
        const returnTo = localStorage.getItem("returnTo");
        if (returnTo) {
            localStorage.removeItem("returnTo");
            history.push(returnTo);
        } else if (user === "user") {
            history.push(`/userInvoice?id=${fallbackInvoiceId}`);
        } else {
            history.push(`/invoice?id=${fallbackInvoiceId}`);
        }
    };

    // Never trusts the browser's own record of what was charged - re-verifies
    // with PayPal server-side and re-validates the plan against each
    // invoice's live balance before applying anything (see
    // controllers/inStorePickup.js's payCardCommit).
    const commitPickupPayment = async (orderId) => {
        const resp = await dispatch(
            handlePostRequest(
                {
                    orderId,
                    mode: pickupPlan.mode,
                    amountReceived: pickupPlan.amountReceived,
                    ...(pickupPlan.selections ? { selections: pickupPlan.selections } : {}),
                },
                `/in-store-pickup/${pickupPlan.pickupId}/pay-card-commit`,
                true,
                true,
            ),
        );
        if (resp?.success) {
            toast.success("Success!!! Thank you for choosing Move4wd. Have a wonderful rest of your day! #MoveYourWorld");
            redirectAfterPayment();
        }
        return resp;
    };

    // const [orderId, setOrderId] = useState();
    const dispatch = useDispatch();
    const getClientToken = async (id) => {
        const res = await handleGetRequest("/GetPaymentToken");
        console.log(res?.data);
        setClientToken(res?.data);
    };
    const getInvoice = async (id) => {
        const res = await handleGetRequest("/specificInvoice/" + id);
        setBrands({
            ...res?.data,
            invoiceAmount: res?.data?.invoiceAmount?.toFixed(2),
            paidAmount: res?.data?.paidAmount?.toFixed(2),
        });
        setAmount(res?.data?.invoiceAmount);
        const reva = (res?.data?.invoiceAmount).toFixed(2);
        setPaidAmount(parseFloat(reva));
        localStorage.setItem("chargeAmount", parseFloat(reva));
    };

    // const getOrderId = async () => {
    //     const res = await dispatch(handlePostRequest({ amount: 25 * 100 }, "/createOrder"));
    //     console.log(res?.data?.id);
    //     setOrderId(res?.data?.id);
    //     return res?.data?.id;
    // };
    useEffect(() => {
        const user = localStorage.getItem("PaymentUser");
        setUser(user);
        if (isPickupPlan) {
            setAmount(pickupPlan.amountReceived);
            setPaidAmount(pickupPlan.amountReceived);
            localStorage.setItem("chargeAmount", pickupPlan.amountReceived);
        } else {
            const id = localStorage.getItem("invoiceId");
            getInvoice(id);
        }
        getClientToken();
        setRole(localStorage.getItem("role"));
        const expirationTime = localStorage.getItem("delayExpiration");
        if (expirationTime) {
            setClosed(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkDelayExpiration = () => {
        const expirationTime = localStorage.getItem("delayExpiration");
        if (expirationTime) {
            const currentTime = new Date().getTime();
            if (currentTime > parseInt(expirationTime)) {
                localStorage.removeItem("delayExpiration");
                setClosed(false);
            }
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            checkDelayExpiration();
        }, 1000); // Check every second
        return () => clearInterval(interval);
    }, []);

    // Passed as the `style` prop on <PayPalHostedField> - that component
    // just spreads its props onto a plain <div> (PayPal's SDK later injects
    // an iframe into it by matching options.selector), so this is ordinary
    // CSS on an element we fully own - safe to restyle freely.
    const CUSTOM_FIELD_STYLE = {
        border: "1px solid #cbd5e1",
        height: "42px",
        borderRadius: "8px",
        marginTop: "5px",
        padding: "0 0.25rem",
    };

    const createOrder = async (data, actions) => {
        console.log(brands);
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        currency_code: "USD",
                        value: isPickupPlan ? pickupPlan.amountReceived : brands?.invoiceAmount,
                    },
                },
            ],
        });
    };

    const onApprove = async (data, actions) => {
        return actions.order
            .capture()
            .then(async function (details) {
                console.log(details);
                if (isPickupPlan) {
                    const orderId = data?.orderID || data?.orderId;
                    const resp = await commitPickupPayment(orderId);
                    if (!resp?.success) {
                        setLoading(false);
                        setDisabled(false);
                    }
                    return;
                }
                const dat = {
                    invoiceNo: details?.purchase_units?.[0]?.payments?.captures?.[0]?.id || details?.id,
                    id: brands?._id,
                    paymentStatus: "paid",
                    paidAmount: paidAmount,
                    invoiceAmount: parseFloat(brands?.invoiceAmount),
                    paymentMethod: "Paypal",
                };
                handlePutRequest(dat, "/markInvoicePaid").then((res) => {
                    if (res?.success) {
                        toast.success("payment successful");
                        const delayTime = new Date().getTime() + 1 * 60 * 1000; // 2 minutes in milliseconds
                        localStorage.setItem("delayExpiration", delayTime);
                        redirectAfterPayment(brands?._id);
                        localStorage.removeItem("invoiceId");
                        localStorage.removeItem("PaymentUser");
                    } else {
                        setLoading(false);
                        setDisabled(false);
                    }
                    toast.success("Success!!! Thank you for choosing Move4wd. Have a wonderful rest of your day! #MoveYourWorld");
                });
            })
            .catch((err) => {
                console.log(err);
                toast.error("We appreciate your effort to make a payment. Please check your card information for errors, or try again in ten minutes.");
            });
    };

    const handlePaymentSuccess = async (id,amount) => {
        const Invid=localStorage.getItem("invoiceId");
        const buyer=localStorage.getItem("buyer");
        const dat = {
            invoiceNo: id,
            id: Invid,
            paymentStatus: "paid",
            paidAmount: amount,
            invoiceAmount: amount,
            paymentMethod:"AmazonPay",
            paymentOwner:buyer,
        };
        const resp = await handlePutRequest(dat, "/markInvoicePaid");
        if (resp?.success) {
            redirectAfterPayment(Invid);
            localStorage.removeItem("invoiceId");
            localStorage.removeItem("PaymentUser");
            localStorage.removeItem("chargeAmount");
            localStorage.removeItem("sessionId");
            localStorage.removeItem("buyer");
        } else {
            setLoading(false);
            setDisabled(false);
        }

        console.log("Payment successful",id,amount,amount,Invid);
    }

    // if (form) {
    //     form.addEventListener("submit", function (event) {
    //         event.preventDefault();
    //         setDisabled(true);
    //         setLoading(true);
    //         // Use the iframe's tokenization method with the user-entered card details
    //         clover.createToken().then(async function (result) {
    //             if (result.errors) {
    //                 setDisabled(false);
    //                 setLoading(false);
    //                 toast.error("Payment failed. Please try again later");
    //                 window.location.reload();
    //             } else {
    //                 console.log(`cloverTokenHandler ${JSON.stringify(result?.token)}`);
    //                 if (result?.token) {
    //                     const data = {
    //                         amount: brands?.invoiceAmount * 100,
    //                         source: result?.token,
    //                     };
    //                     await Axios.post(DEV + "/makeCharge", data)
    //                         .then(async (res) => {
    //                             console.log(res?.data?.data?.id);
    //                             if (res?.data?.data?.id) {
    //                                 const dat = {
    //                                     invoiceNo: res?.data?.data?.id,
    //                                     id: brands?._id,
    //                                     paymentStatus: "paid",
    //                                 };
    //                                 const resp = await handlePutRequest(dat, "/markInvoicePaid");
    //                                 if (resp?.success) {
    //                                     toast.success("payment successful");
    //                                     if (user === "user") {
    //                                         history.push(`/userInvoice?id=${brands?._id}`);
    //                                     } else {
    //                                         history.push(`/invoice?id=${brands?._id}`);
    //                                     }
    //                                     localStorage.removeItem("invoiceId");
    //                                     localStorage.removeItem("PaymentUser");
    //                                 } else {
    //                                     setLoading(false);
    //                                     setDisabled(false);
    //                                 }
    //                             }
    //                         })
    //                         .catch((err) => {
    //                             window.location.reload();
    //                             toast.error("Payment failed. Please try again later");
    //                             setDisabled(false);
    //                             setLoading(false);
    //                         });
    //                 } else {
    //                     setDisabled(false);
    //                     setLoading(false);
    //                     toast.error("Payment failed. Please try again later");
    //                     window.location.reload();
    //                 }
    //             }
    //         });
    //     });
    // }

    //production clover sdk
    //https://checkout.clover.com/sdk.js

    const [checked, setChecked] = useState(false);
    const [summaryOpen, setSummaryOpen] = useState(false);

    // An additional invoice's entire content is its own additionalCharges
    // list (rendered separately below) - the flat fields below are only a
    // report-compatibility mirror of those same amounts, so showing both
    // here would double up every charge under two different labels. It also
    // never represents real shipped weight, so none of the package/weight
    // rendering applies to it either.
    const isAdditional = brands?.invoiceCategory === "additional";

    // Goods bought for the client: shown as its own items list, with every
    // shipping-specific row (weight, per-pound price, add-ons) hidden.
    const isPurchase = brands?.invoiceCategory === "purchase";
    const hideShipping = isAdditional || isPurchase;

    // Purely presentational - every row here is read-only display driven
    // straight off `brands`, same shape/conditions as before, just
    // collapsed out of ~10 repeated JSX blocks into one data-driven list.
    const feeRows =
        brands?.invoiceType !== "Monthly" && !hideShipping
            ? [
                  { key: "price", label: "Cost of Goods", value: brands?.itemsPrice },
                  { key: "oversize", label: brands?.type === "sea" ? "Handling" : "Oversize Fee", value: brands?.oversizeFee },
                  { key: "packaging", label: "Packaging", value: brands?.packagingFee },
                  { key: "pickup", label: "Pickup", value: brands?.pickupFee },
                  { key: "delivery", label: "Delivery", value: brands?.deliveryFee },
                  { key: "handling", label: "Handling", value: brands?.handling },
                  { key: "insurance", label: "Insurance", value: brands?.insurance },
                  { key: "declaration", label: brands?.type === "sea" ? "Pre-Clearance" : "Declaration Fee", value: brands?.declarationFee },
                  { key: "custom", label: "Custom Duties", value: brands?.customDuties },
                  { key: "dangerous", label: "Dangerous Item Fee", value: brands?.dangerousItemFee },
              ]
            : [];

    return (
        <>
            <div className={styles.pageContainer}>
              <div className={styles.contentWrap}>
                <div className={styles.amountHero}>
                    <p className={styles.amountLabel}>Amount Due</p>
                    <p className={styles.amountValue}>${paidAmount}</p>
                </div>

                <div className={styles.layout}>
                    <div className={styles.summaryCard}>
                        <button type="button" className={styles.summaryToggle} aria-expanded={summaryOpen} onClick={() => setSummaryOpen((prev) => !prev)}>
                            <span className={styles.summaryTitle}>
                                Order Summary <span className={styles.summaryTitleAmount}>(${paidAmount})</span>
                            </span>
                            <i className="pi pi-chevron-down" />
                        </button>
                        {summaryOpen && isPickupPlan && (
                            <div className={styles.summaryBody}>
                                <p style={{ margin: 0, fontSize: "13.5px", color: "#475569" }}>
                                    In-store pickup payment - {pickupPlan.mode === "selective" ? "selected invoices" : "applied oldest-invoice-first"} for a total of ${pickupPlan.amountReceived.toFixed(2)}.
                                </p>
                            </div>
                        )}
                        {summaryOpen && !isPickupPlan && (
                        <div className={styles.summaryBody}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>{isPurchase ? "Item" : hideShipping ? "Description" : "Product"}</th>
                                    <th>{isPurchase ? "Qty" : hideShipping ? "" : brands?.type === "sea" ? "Size" : "Weight"}</th>
                                    <th>{isPurchase ? "Unit Price" : hideShipping ? "" : "Price"}</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isAdditional &&
                                    brands?.additionalCharges?.map((charge, index) => (
                                        <tr className={styles.row} key={index}>
                                            <td>{charge.label}</td>
                                            <td></td>
                                            <td></td>
                                            <td>${Number(charge.amount).toFixed(2)}</td>
                                        </tr>
                                    ))}

                                {isPurchase &&
                                    brands?.purchase?.items?.map((item, index) => (
                                        <tr className={styles.row} key={index}>
                                            <td>
                                                {item.url ? (
                                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                        {item.description}
                                                    </a>
                                                ) : (
                                                    item.description
                                                )}
                                            </td>
                                            <td>{item.quantity}</td>
                                            <td>${Number(item.unitPrice).toFixed(2)}</td>
                                            <td>${(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)}</td>
                                        </tr>
                                    ))}

                                {isPurchase && Number(brands?.purchase?.shipping) > 0 && (
                                    <tr className={styles.row}>
                                        <td>Merchant Shipping</td>
                                        <td></td>
                                        <td></td>
                                        <td>${Number(brands.purchase.shipping).toFixed(2)}</td>
                                    </tr>
                                )}
                                {isPurchase && Number(brands?.purchase?.tax) > 0 && (
                                    <tr className={styles.row}>
                                        <td>Tax</td>
                                        <td></td>
                                        <td></td>
                                        <td>${Number(brands.purchase.tax).toFixed(2)}</td>
                                    </tr>
                                )}

                                {brands?.invoiceType !== "Monthly" &&
                                    !hideShipping &&
                                    brands?.packages?.map((item, index) => {
                                        let temp;
                                        let prev = brands?.packages[index - 1]?.product;
                                        if (brands?.customerType === "client") {
                                            if (brands?.size === "sea") {
                                                temp = "Total Size of Cargo";
                                            } else {
                                                if (item?.product === prev) {
                                                    temp = "Additional Pounds";
                                                } else {
                                                    temp = "1st Pound of Cargo";
                                                }
                                            }
                                        } else {
                                            if (brands?.type === "sea") {
                                                temp = "Total Size of Cargo";
                                            } else {
                                                temp = "Total Pounds of Cargo";
                                            }
                                        }
                                        return (
                                            <tr className={styles.row} key={item?._id || index}>
                                                <td>{temp}</td>
                                                <td>{item?.weight} lb</td>
                                                <td>${item?.price}</td>
                                                <td>${(item?.total).toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}

                                {feeRows.map(
                                    (row) =>
                                        row.value !== 0 && (
                                            <tr className={styles.row} key={row.key}>
                                                <td className={styles.addOnLabelCell}>{row.label}</td>
                                                <td></td>
                                                <td></td>
                                                <td>${row.value}</td>
                                            </tr>
                                        ),
                                )}

                                {brands?.invoiceType === "Monthly" && !hideShipping && (
                                    <tr className={styles.row}>
                                        <td>Monthly Fee</td>
                                        <td></td>
                                        <td></td>
                                        <td>${brands?.MonthlyFee}</td>
                                    </tr>
                                )}

                                {brands?.invoiceType === "Monthly" && !hideShipping && (
                                    <tr className={styles.row}>
                                        <td>Website usage Fee</td>
                                        <td></td>
                                        <td></td>
                                        <td>${brands?.WebsiteFee}</td>
                                    </tr>
                                )}

                                <tr className={`${styles.row} ${styles.subtotalRow}`}>
                                    <td>Sub-Total</td>
                                    <td></td>
                                    <td></td>
                                    <td>${brands?.customerType === "partner" || brands?.customerType === "admin" ? brands?.TotalAmount : brands?.invoiceAmount}</td>
                                </tr>
                                {brands?.customerType === "partner" ||
                                    (brands?.customerType === "admin" && (
                                        <tr className={styles.row}>
                                            <td>{brands?.customerType === "partner" ? "Credit Discount" : "Admin Discount"}</td>
                                            <td></td>
                                            <td></td>
                                            <td>- ${brands?.discountedAmount}</td>
                                        </tr>
                                    ))}

                                <tr className={styles.row}>
                                    <td>Tax</td>
                                    <td></td>
                                    <td></td>
                                    <td>$0</td>
                                </tr>

                                {brands?.paymentStatus === "pending" && !(brands?.paidAmount > 0) ? (
                                    <tr className={`${styles.row} ${styles.totalRow}`}>
                                        <td>Total</td>
                                        <td></td>
                                        <td></td>
                                        <td>${brands?.invoiceAmount}</td>
                                    </tr>
                                ) : null}
                                {brands?.paymentStatus === "pending" && brands?.paidAmount > 0 ? (
                                    <>
                                        <tr className={styles.row}>
                                            <td>Paid Amount</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.paidAmount}</td>
                                        </tr>

                                        <tr className={`${styles.row} ${styles.totalRow}`}>
                                            <td>Remaining Amount</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.invoiceAmount}</td>
                                        </tr>
                                    </>
                                ) : null}
                                {brands?.paymentStatus === "paid" ? (
                                    <tr className={`${styles.row} ${styles.totalRow}`}>
                                        <td>Total</td>
                                        <td></td>
                                        <td></td>
                                        <td>${brands?.paidAmount}</td>
                                    </tr>
                                ) : null}
                            </tbody>
                        </table>
                        </div>
                        )}
                    </div>
                    <div className={styles.expressRow}>
                        {clientToken && amount > 0 && (
                            <PayPalScriptProvider
                                options={{
                                    clientId: "AXOElk_LhRFd7dSbyMw3lhfQvGcngnNi56aKp9vyicSf6VfRqi2cdw4Cp8DSvrxArDl8Op8CKBGifxAi",
                                    dataClientToken: clientToken,
                                    components: "hosted-fields,buttons",
                                    intent: "capture",
                                    vault: false,
                                    currency: "USD",
                                }}
                                onError={(err) => {
                                    console.log(err);
                                }}
                            >
                                <div className={styles.expressButton}>
                                    <p className={styles.expressLabel}>
                                        <i className="pi pi-wallet" /> PayPal
                                    </p>
                                    {brands && <PayPalButtons style={{ layout: "horizontal", shape: "pill" }} createOrder={createOrder} onApprove={onApprove}></PayPalButtons>}
                                </div>
                            </PayPalScriptProvider>
                        )}
                        {amount && !isPickupPlan && (
                            <div className={styles.expressButton}>
                                <p className={styles.expressLabel}>
                                    <i className="pi pi-amazon" /> Amazon Pay
                                </p>
                                <div className={styles.amazonWrap}>
                                    <AmazonPayButton handlePaymentSuccess={handlePaymentSuccess} amount={paidAmount} />
                                </div>
                            </div>
                        )}
                    </div>

                    {clientToken && amount > 0 && (
                        <div className={styles.cardSection}>
                            <p className={styles.columnTitle}>
                                <i className="pi pi-credit-card" /> Pay by Card
                            </p>
                            {/* Separate PayPalScriptProvider instance, same options/onError as the
                                one above - PayPal's script loader dedupes by URL+attributes
                                (see findScript/existingWindowNamespace in @paypal/paypal-js), so
                                this reuses the same underlying SDK instance rather than loading
                                it twice. Needed because this card form section is visually
                                separate from the PayPal express button above, and Amazon Pay's
                                visibility must stay independent of clientToken (unchanged from
                                before), so it can't be nested inside one shared provider. */}
                            <PayPalScriptProvider
                                options={{
                                    clientId: "AXOElk_LhRFd7dSbyMw3lhfQvGcngnNi56aKp9vyicSf6VfRqi2cdw4Cp8DSvrxArDl8Op8CKBGifxAi",
                                    dataClientToken: clientToken,
                                    components: "hosted-fields,buttons",
                                    intent: "capture",
                                    vault: false,
                                    currency: "USD",
                                }}
                                onError={(err) => {
                                    console.log(err);
                                }}
                            >
                                <PayPalHostedFieldsProvider
                                    createOrder={async function () {
                                        if (amount === 0) {
                                            toast.error("We appreciate your effort to make a payment. Please check your card information or try again in ten minutes.Amount");
                                        } else {
                                            const data = {
                                                amount: amount,
                                            };
                                            const res = await dispatch(handlePostRequest(data, "/createOrder", false, false));
                                            return res?.data?.id;
                                        }
                                    }}
                                    onError={(err) => {
                                        toast.error("this one");
                                        toast.error("We appreciate your effort to make a payment. Please check your card information or try again in ten minutes.");
                                        setLoading(false);
                                    }}
                                >
                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="card-number">
                                            Card Number
                                            <span className={styles.requiredMark}>*</span>
                                        </label>
                                    </div>
                                    <PayPalHostedField
                                        id="card-number"
                                        className="card__number"
                                        style={CUSTOM_FIELD_STYLE}
                                        hostedFieldType="number"
                                        options={{
                                            selector: "#card-number",
                                            placeholder: "4111 1111 1111 1111",
                                        }}
                                    />
                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="cvv">
                                            CVV<span className={styles.requiredMark}>*</span>
                                        </label>
                                    </div>
                                    <PayPalHostedField
                                        id="cvv"
                                        className="card-field"
                                        style={CUSTOM_FIELD_STYLE}
                                        hostedFieldType="cvv"
                                        options={{
                                            selector: "#cvv",
                                            placeholder: "123",
                                            maskInput: true,
                                        }}
                                    />

                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="expiration-date">
                                            Expiration Date
                                            <span className={styles.requiredMark}>*</span>
                                        </label>
                                    </div>
                                    <PayPalHostedField
                                        id="expiration-date"
                                        className="card-field"
                                        style={CUSTOM_FIELD_STYLE}
                                        hostedFieldType="expirationDate"
                                        options={{
                                            selector: "#expiration-date",
                                            placeholder: "MM/YYYY",
                                        }}
                                    />
                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="postal-code">
                                            Postal Code<span className={styles.requiredMark}>*</span>
                                        </label>
                                    </div>
                                    <PayPalHostedField
                                        id="postal-code"
                                        className="postal-field"
                                        style={CUSTOM_FIELD_STYLE}
                                        hostedFieldType="postalCode"
                                        options={{
                                            selector: "#postal-code",
                                            placeholder: "00000", // Example postal code placeholder
                                        }}
                                    />
                                    <p className={styles.postalNote}>PLEASE USE 00000 for the Postal Code when using a Jamaican Debit/Credit Card to make payment.</p>

                                    <SubmitPayment
                                        customStyle={{ border: "1px solid #606060", boxShadow: "2px 2px 10px 2px rgba(0,0,0,0.1)" }}
                                        paidAmount={paidAmount}
                                        brands={brands}
                                        checked={checked}
                                        setChecked={setChecked}
                                        isPickupPlan={isPickupPlan}
                                        commitPickupPayment={commitPickupPayment}
                                        redirectAfterPayment={redirectAfterPayment}
                                        setLoading={setLoading}
                                        setDisabled={setDisabled}
                                        dispatch={dispatch}
                                        closed={closed}
                                    />
                                </PayPalHostedFieldsProvider>
                            </PayPalScriptProvider>
                        </div>
                    )}
                </div>
              </div>
            </div>
        </>
    );
}

export default Payment;
